module.exports = __webpack_public_path__ + "static/media/sustainability-hub.e3db880f.jpg";